"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactions_1 = require("../../stores/reactions");
var runReactionsTasks_1 = __importDefault(require("./runReactionsTasks"));
var playlist_1 = require("../../selectors/playlist");
var generation_1 = require("../../selectors/generation");
var nextTrack_1 = __importDefault(require("../playback/nextTrack"));
var _kernel_container_1 = __importDefault(require("../../../container"));
var player_1 = require("../../selectors/player");
var _kernel_store_types_1 = require("../../types");
var regeneratePlaylist_1 = __importDefault(require("../generation/regeneratePlaylist"));
function dislikeStreamMediafile(mediafileId, streamId) {
    var action = function (dispatch, getState) {
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/dislikeStreamMediafile");
        var state = getState();
        var silentMediafileId = (0, generation_1.selectSilentMediafileId)(state);
        if (mediafileId === silentMediafileId) {
            logger.warn("Cannot dislike silent mediafile", {
                mediafileId: mediafileId,
                streamId: streamId,
                silentMediafileId: silentMediafileId,
            });
            return;
        }
        var task = {
            streamId: streamId,
            id: mediafileId,
            type: "dislike",
        };
        var currentTrack = (0, playlist_1.selectCurrentPlaylistItemWithMediafile)(state);
        var currentStream = (0, generation_1.selectCurrentStreamId)(state);
        var currentPlayState = (0, player_1.selectCurrentPlayState)(state);
        dispatch((0, reactions_1.addDislikeTaskToPending)(task));
        dispatch((0, reactions_1.recalculateDislikes)());
        dispatch((0, runReactionsTasks_1.default)());
        if (mediafileId === (currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.mediafileId) && currentStream === streamId) {
            if (currentPlayState === _kernel_store_types_1.EPlayState.PLAY) {
                logger.info("Disliked currently playing mediafile, skipping to next track", {
                    mediafileId: mediafileId,
                    currentStream: currentStream,
                });
                dispatch((0, nextTrack_1.default)());
            }
            else {
                logger.info("Disliked currently paused mediafile, regenerating playlist", {
                    mediafileId: mediafileId,
                    currentStream: currentStream,
                });
                dispatch((0, regeneratePlaylist_1.default)());
            }
        }
    };
    action.type = dislikeStreamMediafile.type;
    return action;
}
exports.default = dislikeStreamMediafile;
dislikeStreamMediafile.type = "dislikeStreamMediafile";
//# sourceMappingURL=dislikeStreamMediafile.js.map